import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSInputComponent } from 'src/app/shared/components/cs-input/cs-input.component';
import { CSSelectComponent } from 'src/app/shared/components/cs-select/cs-select.component';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { ChatAvatarComponent } from './components/chat-avatar/chat-avatar.component';
import { ChatHeaderComponent } from './components/chat-header/chat-header.component';
import { ChatInputComponent } from './components/chat-input/chat-input.component';
import { ReactionButtonComponent } from './components/reaction-button/reaction-button.component';
import { ReplyPreviewComponent } from './components/reply-preview/reply-preview.component';
import { SendBirdChatComponent } from './sendbird-chat.component';

@NgModule({
  declarations: [SendBirdChatComponent],
  imports: [
    CommonModule,
    LoadingModule,
    FormsModule,
    CSInputComponent,
    ChatInputComponent,
    ChatAvatarComponent,
    CSButtonComponent,
    CSSelectComponent,
    ChatHeaderComponent,
    ReactionButtonComponent,
    ReplyPreviewComponent,
  ],
  exports: [SendBirdChatComponent],
})
export class SendbirdModule {}
